import React, { Fragment, useState } from "react";
import { Markup } from "interweave";
import $ from "jquery";
const COLORS = [
  "#009CAB",
  "#21C48F",
  "#787F13",
  "#C57241",
  "#B54456",
  "#46769D",
  "#B0437C",
  "#8bbf8c",
  "#99a2dc",
  "#ffa490",
  "#6e22b4",
  "#f07aa4",
  "#87e5c2",
];

var acfs;
var confirmInputs;
var pricing;
var currentGroupSize = 0;
var maxGroupSize = 0;
var eventId;
var currentEventInfo;

export const resetCurrentGroupSize = () => {
  currentGroupSize = 0;
};
const NumInput = (props) => {
  const increment = (newValue) => {
    if (currentGroupSize > maxGroupSize && newValue > props.value) {
      currentGroupSize -= 1;
      alert(
        "Please make sure your total person count is not more than " +
          maxGroupSize +
          " people."
      );
    } else {
      props.onIncrement(newValue < 0 ? 0 : newValue);
    }
  };
  var numInput = (
    <input
      key={`${props.key}-input`}
      id={props.id}
      type="number"
      min={props.min}
      max={props.max}
      value={props.value != null ? props.value : 0}
      className={props.className}
    />
  );
  return (
    <div
      key={`${props.key}-fragment`}
      style={{ display: "flex", float: "left" }}
    >
      <label key={`${props.key}-label`}>{props.name}:</label>
      <div className="number-input">
        <button
          key={`${props.key}-arrow-up`}
          onClick={() => {
            if (currentGroupSize > 0 && props.value > 0) {
              currentGroupSize = currentGroupSize - 1;
              increment(props.value - 1);
            }
          }}
        />
        {numInput}
        <button
          key={`${props.key}-input-arrow-down`}
          className="arrow"
          onClick={() => {
            currentGroupSize = currentGroupSize + 1;
            increment(props.value + 1);
          }}
        />
      </div>
    </div>
  );
};

export const PeopleInputs = (props) => {
  console.log(props);
  var numInputs = Object.keys(props.peopleLimits)
    .filter((p) => p != "total")
    .map((p, i) => {
      return (
        <NumInput
          key={`${props.section}-${props.peopleLimits[p].peopleCategoryId}`}
          id={`${props.section}-${props.peopleLimits[p].peopleCategoryId}`}
          className="event-people-num-input"
          value={props.currentValues[p] != null ? props.currentValues[p] : 0}
          name={props.peopleLimits[p].name}
          min={props.peopleLimits[p].min}
          max={props.peopleLimits[p].max}
          onIncrement={(qty) => {
            console.log(currentGroupSize);
            props.callback({ id: p, qty: qty });
          }}
        />
      );
    });

  numInputs.push(
    <span className="max-group-size">
      Max Group Size: {props.peopleLimits["total"].max}
    </span>
  );

  return <div key={props.key}>{numInputs}</div>;
};

const onProductSelect = (activity, callback) => {
  $.ajax({
    type: "GET",
    url: "/activity",
    data: { productId: activity.id },
    success: function (result) {
      console.log(result);
      if (result.errorId) {
        alert(result.message);
      }
      loadProductInfo(result);
      callback(result);
    },
    error: function (xhr, status, error) {
      console.log(error);
    },
  });
};

const getEventOptions = (options) => {
  console.log(options);
  return options.map((option) => {
    if (option.enabled && option.shownToCustomers)
      return (
        "<div>" +
        option.name +
        '</div><input id="' +
        option.id +
        '" type="text" />'
      );
  });
};

const loadProductInfo = (eventInfo) => {
  $("#booking-form-header").text(eventInfo.name);
  $("#booking-form-event-description").html(
    eventInfo.description.replace(/(<([^>]+)>)/gi, "")
  );
  $("#booking-form-options").html(
    eventInfo.options != null ? getEventOptions(eventInfo.options) : ""
  );

  pricing = {};
  for (var property in eventInfo.people_limits) {
    var data = eventInfo.people_limits[property];
    if (property != "total") {
      if (data.price) {
        var price = data.price.amount;
        pricing[property] = "$" + price;
      } else {
        console.log("Free");
        pricing[property] = "$0";
      }
    } else {
      maxGroupSize = data.max;
      var maxGroupSpan = document.createElement("SPAN");
      maxGroupSpan.innerHTML = "Max Group Size: " + data.max;
      maxGroupSpan.setAttribute("class", "max-group-size");
    }
  }
  console.log(currentEventInfo);
  console.log(pricing);
};

const loadCalendar = (productId, date, peopleNumbers, callback) => {
  console.log(date);
  $.ajax({
    type: "GET",
    url: "/booking_calendar",
    data: { date: date, productId: productId, peopleNumbers: peopleNumbers },
    success: function (result) {
      console.log(result);
      if (result.errorId) {
        alert(result.message);
      }
      callback(result);
    },
    error: function (xhr, status, error) {
      console.log(error);
    },
  });
};

export const searchAvailableSlots = (productInfo, people, date, callback) => {
  console.log(productInfo);
  console.log(people);
  console.log(date);

  if (currentGroupSize == 0) {
    alert("Please add at least 1 attendee!");
    return;
  }

  var peopleNumbers = Object.keys(people).map((pid) => {
    return { peopleCategoryId: pid, number: people[pid] };
  });

  loadCalendar(productInfo.id, date, peopleNumbers, callback);
};

export const getCurrentCosts = (productInfo, people) => {
  var currentCosts = Object.keys(people).map((pid) => {
    return {
      label: productInfo.people_limits[pid].name + " Total",
      price: productInfo.people_limits[pid].price
        ? productInfo.people_limits[pid].price.amount * people[pid]
        : 0,
    };
  });

  currentCosts.push({
    label: "Group Total",
    price: currentCosts.reduce((a, b) => +a + +b.price, 0),
    extra: "(Group Rates Applied at Checkout)",
  });
  console.log(currentCosts);
  return currentCosts;
};

export const getTotalCosts = (productInfo, people) => {
  let total = 0.0;
  Object.keys(people).map((pid) => {
    total += productInfo.people_limits[pid].price
      ? productInfo.people_limits[pid].price.amount * people[pid]
      : 0.0;
  });

  return total;
};

export const createHold = (
  productInfo,
  slot,
  people,
  customer,
  onSuccess,
  onError
) => {
  var peopleNumbers = Object.keys(people).map((pid) => {
    return { peopleCategoryId: pid, number: people[pid] };
  });

  var priceBook = {};
  for (var id in pricing) {
    priceBook[id.replace("activity_", "")] = pricing[id];
  }

  var options = [];

  if (productInfo.options) {
    options = productInfo.options.map((option) => {
      return { id: option.id, value: $("#" + option.id).val() };
    });
  }

  console.log(options);

  var params = {
    productName: productInfo.name,
    productId: productInfo.id,
    eventId: slot.id,
    startTime: slot.startTime,
    endTime: slot.endTime,
    peopleNumbers: peopleNumbers,
    priceBook: priceBook,
    customer: customer,
    options: options,
  };

  console.log(params);
  $.post("/book", params, function (data, status) {
    console.log(data);
    if (data.errorId) {
      if (onError != null) {
        onError(data.message);
      } else {
        alert(data.message);
      }
    } else {
      onSuccess(data);
      // window.location.replace(data.checkout.checkout_page_url);
    }
  });
};

export const getActivities = (activities, currentProduct, callback) => {
  var colorCount = -1;
  return activities.map((a) => {
    colorCount += 1;
    return (
      <Fragment key={a.id}>
        <div
          key={`container-${a.id}`}
          className={`event-type${
            currentProduct != null && a.id == currentProduct.id
              ? " selected"
              : ""
          }`}
          onClick={() => onProductSelect(a, callback)}
          style={{ "--color": COLORS[colorCount] }}
        >
          <p htmlFor={a.id} style={{ "--color": COLORS[colorCount] }}>
            {a.name}
          </p>
          <span class="product-short-description">
            <Markup content={a.short_description} />
          </span>
        </div>
      </Fragment>
    );
  });
};

export const bookingAPICall = (type, endpoint, params, callback) => {
  fetch(endpoint, {
    method: type, // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: type != "GET" ? JSON.stringify(params) : null,
  })
    .then((response) => response.json())
    .then((data) => callback(data));
};

export const PeopleTotalCosts = (props) => {
  return (
    <Fragment>
      {getCurrentCosts(props.productInfo, props.people).map((cost) => {
        return (
          <div>
            <span>{cost.label + ": "}</span>
            <span>{"$" + cost.price}</span>
            <span>{cost.extra != null ? " " + cost.extra : ""}</span>
          </div>
        );
      })}
    </Fragment>
  );
};

export const Calendar = (props) => {
  if (props.calendar) {
    return (
      <div id="calendar-container">
        <div className={props.calendar.title.class}>
          {props.calendar.title.content}
        </div>
        <div className="calendar table table-bordered table-striped">
          <div className="calendar-header-row">
            {props.calendar.rows.weekdays.map((weekday) => {
              return <h6 className="">{weekday}</h6>;
            })}
          </div>
          {props.calendar.rows.day_rows.map((day_row) => {
            return (
              <div className="calendar-week-row">
                {day_row.map((day_item) => {
                  return (
                    <div
                      key={"day-" + day_item.day}
                      className={day_item.classes}
                    >
                      <p className="day-label">{day_item.day}</p>
                      <p className="date-label">{day_item.long_date}</p>
                      <div className="available-slots-container">
                        {day_item.available_slots.map((slot) => {
                          return (
                            <div
                              key={slot.id}
                              className="available-slot"
                              onClick={() => props.onSlotClicked(slot)}
                            >
                              {slot.label}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return <div id="calendar-container"></div>;
  }
};

export const SelecOptions = () => {
  var year = new Date().getFullYear();
  var years = [year, year + 1, year + 2];
  return years.map((y) => {
    return <option value={y}>{y}</option>;
  });
};
